import React from "react";
import { Spinner } from "@public/ui-toolkit";

const OverviewAbout = ({
  phoneNumber,
  foundedDate,
  headquarterAddress,
  overview,
  websiteUrl,
  investorType,
  loading,
}) => {
  return (
    <div className="overview-content-container">
      {!loading ? (
        <>
          <div className="overview-content-head">
            <div className="d-flex justify-content-between">
              <h5 className="overview-content-title mb-4">Overview</h5>

            </div>
            <p className="overview-content-detail">{overview}</p>
          </div>
          <div className="row mt-5">
            <div className="col-md-6">
              <h6>Website</h6>
            </div>
            <div className="col-md-6">
              <p className="text-blue">{websiteUrl}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h6>Phone number</h6>
            </div>
            <div className="col-md-6">
              <p className="text-blue">{phoneNumber}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h6>Investor Type</h6>
            </div>
            <div className="col-md-6">
              <p className="text-blue">{investorType}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h6>Founded</h6>
            </div>
            <div className="col-md-6">
              <p className="text-blue">{foundedDate}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h6>Headquarter</h6>
            </div>
            <div className="col-md-6">
              <p className="text-blue">{headquarterAddress}</p>
            </div>
          </div>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default OverviewAbout;
